"use strict";

exports.__esModule = true;
exports.ManualEventsContext = exports.ManualEventSupplier = void 0;
var _react = _interopRequireDefault(require("react"));
var _API = require("../../API");
var _Notifications = require("../../Notifications");
var _UI = require("../../../Utils/UI");
var _Translator = require("../../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var ManualEventsContext = exports.ManualEventsContext = /*#__PURE__*/_react["default"].createContext({});
var getPartCount = function getPartCount(part) {
  if (part && Array.isArray(part.by_device) && part.by_device[0]) {
    return part.by_device[0].value;
  }
  return 0;
};
var ManualEventSupplier = exports.ManualEventSupplier = function ManualEventSupplier(props) {
  var api = _react["default"].useContext(_API.RestAPIContext);
  var _React$useContext = _react["default"].useContext(_Notifications.NotificationContext),
    showNotification = _React$useContext.showNotification;
  var _React$useContext2 = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext2.translate;
  var consumerProps = {
    postQuery: function postQuery(_ref) {
      var goodParts = _ref.goodParts,
        badParts = _ref.badParts;
      var array = [];
      if (goodParts && goodParts.part_count !== 0) {
        array.push(api.post("/api/v3/enrich-input/", Object.assign({}, goodParts, {
          plant: api.plantName
        })));
      }
      if (badParts && badParts.part_count !== 0) {
        array.push(api.post("/api/v3/enrich-input/", Object.assign({}, badParts, {
          plant: api.plantName
        })));
      }
      return Promise.all(array);
    },
    addPartCount: function () {
      var _addPartCount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref2) {
        var goodParts, badParts, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              goodParts = _ref2.goodParts, badParts = _ref2.badParts;
              _context.p = 1;
              _context.n = 2;
              return consumerProps.postQuery({
                goodParts: goodParts,
                badParts: badParts
              });
            case 2:
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.warn(_t);
              return _context.a(2, _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3]]);
      }));
      function addPartCount(_x) {
        return _addPartCount.apply(this, arguments);
      }
      return addPartCount;
    }(),
    undoAddPartCount: function () {
      var _undoAddPartCount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref3) {
        var goodParts, badParts, undoGoodParts, undoBadParts, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              goodParts = _ref3.goodParts, badParts = _ref3.badParts;
              undoGoodParts = Object.assign({}, goodParts, {
                part_count: -Math.abs(goodParts.part_count)
              });
              undoBadParts = Object.assign({}, badParts, {
                part_count: -Math.abs(badParts.part_count)
              });
              _context2.p = 1;
              _context2.n = 2;
              return consumerProps.postQuery({
                goodParts: undoGoodParts,
                badParts: undoBadParts
              });
            case 2:
              showNotification(_Notifications.NOTIFICATION_UNDONE_PART_KIND);
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              console.warn(_t2);
              return _context2.a(2, _t2);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, null, [[1, 3]]);
      }));
      function undoAddPartCount(_x2) {
        return _undoAddPartCount.apply(this, arguments);
      }
      return undoAddPartCount;
    }(),
    getBadProcessCount: function () {
      var _getBadProcessCount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(device, reportingPeriod, prtKind) {
        var query, resp, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              query = {
                filters: {
                  must: [{
                    filterType: "range",
                    fieldName: "timestamp",
                    values: {
                      gte: new Date(reportingPeriod.interval.startMillis).toISOString(),
                      lt: new Date(reportingPeriod.interval.endMillis).toISOString()
                    }
                  }, {
                    filterType: "terms",
                    fieldName: "device_id",
                    values: [device.uuid]
                  }, {
                    filterType: "terms",
                    fieldName: "kind_id",
                    values: [prtKind]
                  }, {
                    filterType: "term",
                    fieldName: "plant_id",
                    values: api.plantName
                  }],
                  mustNot: []
                },
                bins: [{
                  binName: "by_device",
                  fieldName: "device_id",
                  aggType: "terms",
                  options: {}
                }],
                metrics: ["bad_part_count"]
              };
              _context3.p = 1;
              _context3.n = 2;
              return api.post("/api/v3/timeseries-metrics/", query);
            case 2:
              resp = _context3.v;
              return _context3.a(2, getPartCount(resp));
            case 3:
              _context3.p = 3;
              _t3 = _context3.v;
              console.warn(_t3);
              return _context3.a(2, _t3);
          }
        }, _callee3, null, [[1, 3]]);
      }));
      function getBadProcessCount(_x3, _x4, _x5) {
        return _getBadProcessCount.apply(this, arguments);
      }
      return getBadProcessCount;
    }(),
    getGoodProcessCount: function () {
      var _getGoodProcessCount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(device, reportingPeriod, prtKind) {
        var query, resp, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              query = {
                filters: {
                  must: [{
                    filterType: "range",
                    fieldName: "timestamp",
                    values: {
                      gte: new Date(reportingPeriod.interval.startMillis).toISOString(),
                      lt: new Date(reportingPeriod.interval.endMillis).toISOString()
                    }
                  }, {
                    filterType: "terms",
                    fieldName: "device_id",
                    values: [device.uuid]
                  }, {
                    filterType: "terms",
                    fieldName: "kind_id",
                    values: [prtKind]
                  }, {
                    filterType: "term",
                    fieldName: "plant_id",
                    values: api.plantName
                  }],
                  mustNot: []
                },
                bins: [{
                  binName: "by_device",
                  fieldName: "device_id",
                  aggType: "terms",
                  options: {}
                }],
                metrics: ["good_part_count"]
              };
              _context4.p = 1;
              _context4.n = 2;
              return api.post("/api/v3/timeseries-metrics/", query);
            case 2:
              resp = _context4.v;
              return _context4.a(2, getPartCount(resp));
            case 3:
              _context4.p = 3;
              _t4 = _context4.v;
              console.warn(_t4);
              return _context4.a(2, _t4);
          }
        }, _callee4, null, [[1, 3]]);
      }));
      function getGoodProcessCount(_x6, _x7, _x8) {
        return _getGoodProcessCount.apply(this, arguments);
      }
      return getGoodProcessCount;
    }(),
    changePartKind: function () {
      var _changePartKind = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(device, partKind) {
        var query, response, _t5;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              query = {
                plant: api.plantName,
                input_type: "part-kind",
                device_uuid: device.uuid
              };
              if (partKind) {
                query.kind_id = partKind;
              }
              _context5.p = 1;
              _context5.n = 2;
              return api.post("/api/v3/enrich-input/", query);
            case 2:
              response = _context5.v;
              (0, _UI.showSuccessToaster)(translate("ChangePartKind.save.success", "Part Kind successfully changed"));
              return _context5.a(2, response);
            case 3:
              _context5.p = 3;
              _t5 = _context5.v;
              (0, _UI.showErrorToaster)(translate("ChangePartKind.save.error", "Part Kind could not be changed"));
              console.warn(_t5);
              return _context5.a(2, _t5);
          }
        }, _callee5, null, [[1, 3]]);
      }));
      function changePartKind(_x9, _x0) {
        return _changePartKind.apply(this, arguments);
      }
      return changePartKind;
    }(),
    changePartProcess: function () {
      var _changePartProcess = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(device, partProcess) {
        var query, response, _t6;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              query = {
                plant: api.plantName,
                input_type: "part-process",
                device_uuid: device.uuid
              };
              if (partProcess) {
                query.process_id = partProcess;
              }
              _context6.p = 1;
              _context6.n = 2;
              return api.post("/api/v3/enrich-input/", query);
            case 2:
              response = _context6.v;
              (0, _UI.showSuccessToaster)(translate("ChangePartProcess.save.success", "Part Process successfully changed"));
              return _context6.a(2, response);
            case 3:
              _context6.p = 3;
              _t6 = _context6.v;
              (0, _UI.showErrorToaster)(translate("ChangePartProcess.save.error", "Part Process could not be changed"));
              console.warn(_t6);
              return _context6.a(2, _t6);
          }
        }, _callee6, null, [[1, 3]]);
      }));
      function changePartProcess(_x1, _x10) {
        return _changePartProcess.apply(this, arguments);
      }
      return changePartProcess;
    }(),
    changePartInstance: function () {
      var _changePartInstance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(device, partInstance) {
        var query, response, _t7;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              query = {
                plant: api.plantName,
                input_type: "part-instance",
                device_uuid: device.uuid
              };
              if (partInstance) {
                query.part_instance_id = partInstance;
              }
              _context7.p = 1;
              _context7.n = 2;
              return api.post("/api/v3/enrich-input/", query);
            case 2:
              response = _context7.v;
              (0, _UI.showSuccessToaster)(translate("ChangePartInstance.save.success", "Part Instance successfully changed"));
              return _context7.a(2, response);
            case 3:
              _context7.p = 3;
              _t7 = _context7.v;
              (0, _UI.showErrorToaster)(translate("ChangePartInstance.save.error", "Part Instance could not be changed"));
              console.warn(_t7);
              return _context7.a(2, _t7);
          }
        }, _callee7, null, [[1, 3]]);
      }));
      function changePartInstance(_x11, _x12) {
        return _changePartInstance.apply(this, arguments);
      }
      return changePartInstance;
    }(),
    changeOperator: function () {
      var _changeOperator = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(device, operator) {
        var query, response, _t8;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              query = {
                plant: api.plantName,
                input_type: "operator",
                device_uuid: device.uuid
              };
              if (operator) {
                query.operator = operator;
              }
              _context8.p = 1;
              _context8.n = 2;
              return api.post("/api/v3/enrich-input/", query);
            case 2:
              response = _context8.v;
              (0, _UI.showSuccessToaster)(translate("ChangeOperator.save.success", "Successfully changed the Operator"));
              return _context8.a(2, response);
            case 3:
              _context8.p = 3;
              _t8 = _context8.v;
              (0, _UI.showErrorToaster)(translate("ChangeOperator.save.error", "Operator could not be changed"));
              console.warn(_t8);
              return _context8.a(2, _t8);
          }
        }, _callee8, null, [[1, 3]]);
      }));
      function changeOperator(_x13, _x14) {
        return _changeOperator.apply(this, arguments);
      }
      return changeOperator;
    }(),
    mapPartValue: function () {
      var _mapPartValue = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(device, mappingType, originalValue, mappedValue) {
        var query, toastMessageDict, response, _t9;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              query = {
                device: device.uuid,
                type: mappingType,
                originalValue: originalValue,
                mappedValue: mappedValue
              };
              toastMessageDict = {
                "part-kind-value-mapping": {
                  successMessage: translate("MapPartKind.save.success", "Part Kind mapping queued successfully"),
                  errorMessage: translate("MapPart.save.error", "Failed to map Part Kind value")
                },
                "part-process-value-mapping": {
                  successMessage: translate("MapPartProcess.save.success", "Part Process mapping queued successfully"),
                  errorMessage: translate("MapPartProcess.save.error", "Failed to map Part Process value")
                },
                "part-instance-value-mapping": {
                  successMessage: translate("MapPartInstance.save.success", "Part Instance mapping queued successfully"),
                  errorMessage: translate("MapPartInstance.save.error", "Failed to map Part Instance value")
                },
                "operator-value-mapping": {
                  successMessage: translate("MapOperator.save.success", "Operator mapping queued successfully"),
                  errorMessage: translate("MapOperator.save.error", "Failed to map Operator value")
                }
              };
              _context9.p = 1;
              _context9.n = 2;
              return api.post("/api/v3/part-operator-mapping/value-mapping/", query);
            case 2:
              response = _context9.v;
              (0, _UI.showSuccessToaster)(toastMessageDict[mappingType].successMessage);
              return _context9.a(2, response);
            case 3:
              _context9.p = 3;
              _t9 = _context9.v;
              (0, _UI.showErrorToaster)(toastMessageDict[mappingType].errorMessage);
              console.warn(_t9);
              return _context9.a(2, _t9);
          }
        }, _callee9, null, [[1, 3]]);
      }));
      function mapPartValue(_x15, _x16, _x17, _x18) {
        return _mapPartValue.apply(this, arguments);
      }
      return mapPartValue;
    }()
  };
  return /*#__PURE__*/_react["default"].createElement(ManualEventsContext.Provider, {
    value: consumerProps
  }, props.children);
};